import { Component } from '@angular/core';
import { MailReportComponent as LibMailReportComponent } from '@nucleus/mail-report-ui';

/**
 * Thin shell hosting `<lib-mail-report>` from `@nucleus/mail-report-ui`.
 * DI tokens registered at ReportsModule level via
 * `NUCLEUS_MAIL_UI_PROVIDERS`.
 */
@Component({
  selector: 'app-mail-report',
  standalone: false,
  template: '<lib-mail-report></lib-mail-report>',
  styles: [':host { display: flex; flex-direction: column; height: 100%; }'],
})
export class MailReportComponent {}
